/**
 * Centralized configuration constants for the Artefacts feature
 */

export const ARTEFACT_CONFIG = {
  /**
   * Panel configuration
   */
  panel: {
    minWidth: 250,
    maxWidthPercent: 0.5,
    defaultWidth: 400,
  },

  /**
   * Detection configuration
   */
  detection: {
    minCodeLines: 3,
    minDocumentChars: 100,
    minTableRows: 2,
    maxTableDisplayRows: 100,
  },

  /**
   * Iframe configuration
   */
  iframe: {
    defaultHeight: 400,
    maxHeight: 800,
    refreshDelay: 100,
  },

  /**
   * File extension mappings
   */
  fileExtensions: {
    fallback: "txt",
  },

  /**
   * Language styling configuration
   */
  languages: {
    javascript: { name: "JavaScript", color: "text-yellow-600", bg: "bg-yellow-50" },
    js: { name: "JavaScript", color: "text-yellow-600", bg: "bg-yellow-50" },
    typescript: { name: "TypeScript", color: "text-blue-600", bg: "bg-blue-50" },
    ts: { name: "TypeScript", color: "text-blue-600", bg: "bg-blue-50" },
    python: { name: "Python", color: "text-green-600", bg: "bg-green-50" },
    py: { name: "Python", color: "text-green-600", bg: "bg-green-50" },
    html: { name: "HTML", color: "text-orange-600", bg: "bg-orange-50" },
    css: { name: "CSS", color: "text-purple-600", bg: "bg-purple-50" },
    json: { name: "JSON", color: "text-indigo-600", bg: "bg-indigo-50" },
    sql: { name: "SQL", color: "text-teal-600", bg: "bg-teal-50" },
    default: { name: "Code", color: "text-gray-600", bg: "bg-gray-50" },
  },
} as const;

/**
 * Error handling configuration
 */
export const ARTEFACT_ERRORS = {
  copy: "Failed to copy artefact",
  download: "Failed to download artefact",
  render: "Failed to render artefact content",
  detection: "Failed to detect artefact type",
} as const;
